var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(!_vm.loading)?_c('h6',{staticClass:"",attrs:{"dir":"ltr"}},[_vm._v(" "+_vm._s(_vm.items['use_subscription_storage'])+" MB / "+_vm._s(Math.round(parseInt(_vm.items['storage_size'])))+" MB ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }